import React from 'react';
import picoinsbackground from '../../styles/img/background/picoins_background.png';
import PikkoPointContainer from './PikkoPointContainer';

const PikkoPointBox = ({ click, user, earnPoints, pikkoday }) => {
  if (!user || !user._id) {
    return <></>;
  }

  return (
    <div className="pikko-box-container">
      <button className="pikko-box bg-gradient1" onClick={click}>
        <img className="background_light" src={picoinsbackground} />
        <PikkoPointContainer
          user={user}
          earnPoints={earnPoints}
          pikkoday={pikkoday}
        />
      </button>
    </div>
  );
};
export default PikkoPointBox;
